module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jlavQ"))).then(() => parcelRequire('iDabs'));